import React, {
    useEffect, useState 
} from 'react'
import { Formik, Form } from 'formik'
import {
    FaArrowRight
} from 'react-icons/fa'
import { toast } from 'react-toastify'

import Yup from '~/services/yup'
import { api } from '~/services/api'

import formUtils from '~/util/form'
import { getDate } from '~/util/date'

import {
    Button, Select, File, Calendar 
} from '~/components/Form'
import ActionFooter from '~/components/ActionFooter'

import { Container } from './styles'

const validation = Yup.object({
    faculdade: Yup.string().ensure().required('Especifique sua faculdade.'),
    declaracao: Yup.number().typeError('Envie a declaração da faculdade.').required('Envie a declaração da faculdade.'),
    data_ingresso: Yup.string().nullable().required('Especifique a data de ingresso no curso'),
    data_conclusao: Yup.string().nullable().required('Especifique a provável data de conclusão da sua graduação')
})

export default function ({ callback }) {
    const [faculdades, setFaculdades] = useState([])
    const [initialValues, setInitialValues] = useState({
        faculdade: '',
        declaracao: null,
        data_ingresso: '',
        data_conclusao: ''
    })

    useEffect(() => {
        async function loadFaculdades() {
            const response = await api.get('/faculdade')

            setFaculdades(response)
        }

        loadFaculdades()
    }, [])

    useEffect(() => {
        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        if(storageData?.dados_academicos) {
            const { data_ingresso, data_conclusao, faculdade } = storageData?.dados_academicos

            const response = faculdades.find(f => f.id === faculdade)

            setInitialValues({
                ...storageData.dados_academicos,
                faculdade: response ? { label: response.descricao, value: response.id } : '',
                data_ingresso: getDate(data_ingresso),
                data_conclusao: getDate(data_conclusao)
            })
        }
    }, [faculdades])

    async function handleSubmit(values, { setSubmitting }) {
        const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        storageData.dados_academicos = formUtils.extractFormValues(values)
       
        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storageData))

        try {
            await api.put(`dados_associacao/${storageData.pessoal.cpf}`, storageData)
        } catch(e) {
            toast.error('Ocorreu um erro no processo de associação.')
            setSubmitting(false)
            return
        }

        try {
            await api.post('associacao', storageData)
        } catch(e) {
            toast.error('Ocorreu um erro no processo de associação.')
            setSubmitting(false)
            return
        }

        setSubmitting(false)

        callback(storageData.pessoal.cpf)
    }
    
    return (
        <Container>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({
                    isSubmitting, setFieldValue, errors, values 
                }) => (
                    <Form>
                        <Select 
                            name="faculdade"
                            label="Faculdade / Universidade"
                            onChange={(selected, actionMeta) => setFieldValue(actionMeta.name, selected)}
                            options={faculdades.map(faculdade => ({
                                label: faculdade.descricao,
                                value: faculdade.id
                            }))}
                        />

                        <File 
                            name="declaracao"
                            onSuccess={fileId => setFieldValue('declaracao', fileId)}
                            label="Declaração da faculdade"
                            format="square"
                            previewSize={['100%', '150px']}
                            error={errors.declaracao}
                            getPreloadImage={async () => {
                                if(values.declaracao) {
                                    const arquivo = await api.get(`arquivo/${values.declaracao}`)
                                    return arquivo?.link
                                }
                            }}
                            style={{ gridArea: 'declaracao' }}
                        />

                        <Calendar 
                            name="data_ingresso" 
                            dateFormat="mm/yy" 
                            view="month"
                            label="Data de ingresso"
                            yearRange={`${new Date().getFullYear() - 10}:${new Date().getFullYear()}`}
                        />

                        <Calendar 
                            name="data_conclusao" 
                            dateFormat="mm/yy" 
                            view="month"
                            label="Data provável de conclusão"
                            yearRange={`${new Date().getFullYear()}:${new Date().getFullYear() + 6}`}
                        />

                        <ActionFooter>
                            <Button type="submit" loading={isSubmitting} className="white">
                                Continuar
                                <FaArrowRight />
                            </Button>
                        </ActionFooter>
                    </Form>
                )}
            </Formik>

        </Container>
    )
}
